(() => {
  document.documentElement.classList.add('icc-no-marketing-popups');

  if (window.__iccMarketingPopupGuard) return;

  const suppressMarketingPopup = () => {
    document
      .querySelectorAll(
        '[data-testid="POPUP"], [data-testid="POPUP_FORM"], [class*="kl-private-reset-css"]'
      )
      .forEach((element) => {
        const popup = element.matches('[data-testid="POPUP"], [data-testid="POPUP_FORM"]')
          ? element.closest('[role="dialog"]') || element
          : element.closest('[role="dialog"]');
        if (!popup) return;
        popup.style.setProperty('display', 'none', 'important');
        popup.setAttribute('aria-hidden', 'true');
      });

    document.documentElement.style.removeProperty('overflow');
    document.body?.style.removeProperty('overflow');
  };

  const observer = new MutationObserver(suppressMarketingPopup);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
  window.__iccMarketingPopupGuard = observer;
  suppressMarketingPopup();
})();
